/**
 * 项目信息组件
 */
import React from 'react';
import { Typography, Row, Col, Tag, Space } from 'antd';
import {
  CalendarOutlined,
  SyncOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  PauseCircleOutlined,
  ProfileOutlined
} from '@ant-design/icons';
import type { ProjectOverviewData } from '../../services/dashboardService';

const { Text, Title } = Typography;

interface ProjectInfoProps {
  project: ProjectOverviewData;
  isMobile?: boolean;
}

const STATUS_CONFIG: Record<string, { color: string; icon: React.ReactNode; text: string }> = {
  '进行中': { color: 'processing', icon: <SyncOutlined spin />, text: '进行中' },
  '已完成': { color: 'success', icon: <CheckCircleOutlined />, text: '已完成' },
  '待开始': { color: 'default', icon: <ExclamationCircleOutlined />, text: '待开始' },
  '已暂停': { color: 'warning', icon: <PauseCircleOutlined />, text: '已暂停' }
};

const ProjectInfo: React.FC<ProjectInfoProps> = ({
  project,
  isMobile = false
}) => {
  const statusConfig = STATUS_CONFIG[project.status] || STATUS_CONFIG['待开始'];

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return '-';
    return dateStr.split('T')[0];
  };

  return (
    <div
      style={{
        marginBottom: isMobile ? 16 : 24,
        padding: isMobile ? 14 : 18,
        borderRadius: 20,
        background: 'rgba(210, 218, 224, 0.5)',
        border: '1px solid rgba(16, 27, 35, 0.08)'
      }}
    >
      <Title level={5} style={{ marginBottom: 16, fontSize: isMobile ? 14 : 16, color: '#10171d' }}>
        项目信息
      </Title>

      <Row gutter={[16, isMobile ? 10 : 12]}>
        <Col xs={12} sm={12} md={6}>
          <Space size={4}>
            <CalendarOutlined style={{ color: '#547590' }} />
            <Text style={{ fontSize: isMobile ? 12 : 13, color: '#667986' }}>开始日期</Text>
          </Space>
          <div>
            <Text style={{ fontSize: isMobile ? 13 : 14, color: '#10171d' }}>{formatDate(project.startDate)}</Text>
          </div>
        </Col>

        <Col xs={12} sm={12} md={6}>
          <Space size={4}>
            <CalendarOutlined style={{ color: '#5ad1b2' }} />
            <Text style={{ fontSize: isMobile ? 12 : 13, color: '#667986' }}>结束日期</Text>
          </Space>
          <div>
            <Text style={{ fontSize: isMobile ? 13 : 14, color: '#10171d' }}>{formatDate(project.endDate)}</Text>
          </div>
        </Col>

        <Col xs={12} sm={12} md={6}>
          <Text style={{ fontSize: isMobile ? 12 : 13, color: '#667986' }}>项目状态</Text>
          <div style={{ marginTop: 4 }}>
            <Tag color={statusConfig.color} icon={statusConfig.icon} style={{ borderRadius: 999 }}>{statusConfig.text}</Tag>
          </div>
        </Col>

        <Col xs={12} sm={12} md={6}>
          <Space size={4}>
            <ProfileOutlined style={{ color: '#9384ff' }} />
            <Text style={{ fontSize: isMobile ? 12 : 13, color: '#667986' }}>经营记录数</Text>
          </Space>
          <div>
            <Text style={{ fontSize: isMobile ? 13 : 14, color: '#10171d' }}>{project.teamSize} 条</Text>
          </div>
        </Col>

        <Col xs={24} sm={24} md={12}>
          <Text style={{ fontSize: isMobile ? 12 : 13, color: '#667986' }}>最近更新</Text>
          <div>
            <Text style={{ fontSize: isMobile ? 13 : 14, color: '#10171d' }}>{project.recentActivity || '-'}</Text>
          </div>
        </Col>

        <Col xs={24} sm={24} md={12}>
          <Text style={{ fontSize: isMobile ? 12 : 13, color: '#667986' }}>工期状态</Text>
          <div>
            <Text style={{ fontSize: isMobile ? 13 : 14, color: '#10171d' }}>{project.scheduleStatusLabel || '未设置工期'}</Text>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ProjectInfo;
